import { Component, OnInit } from '@angular/core';
import { UserResponseDto } from '../../models/adminResponseDto';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { FibberglassRequestService } from '../../services/fibberglass-request.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';

@Component({
  selector: 'app-fibberglass-contract',
  templateUrl: './fibberglass-contract.component.html',
  styleUrls: ['./fibberglass-contract.component.css']
})
export class FibberglassContractComponent implements OnInit {

  RequestId: string;
  ConfirmContractForm: FormGroup;
  submitted = false;
  loading = false;
  responseObj: ResponseObject;
  showRequest = true;
  readonly : boolean;

  constructor(private fibberglassService: FibberglassRequestService, private route: ActivatedRoute, private router: Router, private global: GlobalServices, private formBuilder: FormBuilder, private authSrevice: AuthenticationService) {
    if (history.state.data && history.state.data.requestId)
      this.RequestId = history.state.data.requestId;
    //this.RequestId = this.route.snapshot.params.Id;
    this.createForm();
    this.readonly = true;
  }

  ngOnInit() {

  }

  get Validate() {
    return this.ConfirmContractForm.controls;
  }

  createForm() {
    this.ConfirmContractForm = this.formBuilder.group({
      ContractConfirmation: ['', Validators.requiredTrue]
    });
  }

  onSubmit() {
    this.submitted = true;
    if (this.ConfirmContractForm.invalid) {
      return;
    }
    //Enable Loader
    this.global.isLoaderEnabled = true;
    this.loading = true;
    var ConfirmResponse = new UserResponseDto();
    ConfirmResponse.response = this.Validate.ContractConfirmation.value ? 1 : 0;
    ConfirmResponse.requestId = this.RequestId;
    ConfirmResponse.userName = this.authSrevice.currentUserValue.UserName;
    this.fibberglassService.ConfirmFibberglassContract(ConfirmResponse).subscribe(
      (data: ResponseObject) => {
        this.responseObj = data;
        if (this.responseObj.Success) {
          this.ConfirmContractForm.reset();
          this.showRequest = false;
          this.loading = false;
          //Disable Loader
          this.global.isLoaderEnabled = false;
          // console.log("Success");
        }
        else {
          this.loading = false;
          //Disable Loader
          this.global.isLoaderEnabled = false;
          // console.log("Fail");
        }
      });
  }
}
